/* import __COLOCATED_TEMPLATE__ from './preview-email.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { type TaskGenerator } from 'ember-concurrency';
import { taskFor } from 'ember-concurrency-ts';
import { task } from 'ember-concurrency-decorators';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type Store from '@ember-data/store';
import { action } from '@ember/object';
import { type TrackedArray } from 'tracked-built-ins';

interface Signature {
  Args: {
    selectedAudiences?: TrackedArray<string>;
  };
  Element: HTMLDivElement;
}

export default class PreviewEmail extends Component<Signature> {
  @service declare store: Store;
  @service declare appService: AppService;
  @service declare intercomEventService: any;

  @tracked declare finPreviewAddress: string;

  constructor(owner: unknown, args: never) {
    super(owner, args);
    taskFor(this.fetchFinPreviewAddress).perform();
  }

  @task({ drop: true })
  *fetchFinPreviewAddress(): TaskGenerator<void> {
    let finPreviewSettings = yield this.store.findRecord(
      'ai-agent/preview-settings',
      this.appService.app.id,
    );

    this.finPreviewAddress = finPreviewSettings.previewAddress;
  }

  get isFetchingFinPreviewAddress() {
    return taskFor(this.fetchFinPreviewAddress).isRunning;
  }

  get displayedPreviewAddress(): string {
    if (!this.finPreviewAddress) {
      return '';
    }

    if (this.args.selectedAudiences?.length === 1) {
      let audienceId = this.args.selectedAudiences[0];
      let [localPart, domain] = this.finPreviewAddress.split('@');
      return `${localPart}+${audienceId}@${domain}`;
    }

    return this.finPreviewAddress;
  }

  @action
  trackCopyEmailAddress() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'preview_email_copy_address',
      place: 'workflow_preview',
      section: 'preview',
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::Preview::PreviewEmail': typeof PreviewEmail;
    'workflows/preview/preview-email': typeof PreviewEmail;
  }
}
